import React from "react";
import { Check } from "lucide-react";
import { ChecklistItemData } from "../types";
import "./ChecklistItem.css";

interface ChecklistItemProps {
  item: ChecklistItemData;
  checked: boolean;
  onToggle: (itemId: string) => void;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({
  item,
  checked,
  onToggle,
}) => {
  return (
    <label
      className={`checklist-item${checked ? " checklist-item--checked" : ""}`}
    >
      <span className="checklist-item__box">
        <input
          type="checkbox"
          checked={checked}
          onChange={() => onToggle(item.id)}
          className="checklist-item__input"
        />
        {checked && <Check size={13} strokeWidth={3} />}
      </span>
      <span className="checklist-item__text">{item.text}</span>
    </label>
  );
};

export default ChecklistItem;
